import { IKidsComboSelectionData } from "../../models/kidsCombo";

const KidsComboSelectionData: IKidsComboSelectionData[] = [
  {
    id: "1",
    title: "item #1",
    sm_title: 'item 1',
    chooseName: "Choose First Item",
    showCustomTitle:false,
    name: "",
    cal: 0,
    image: "",
    flag: "123",
  },
  {
    id: "2",
    title: "item #2",
    sm_title: 'item 2',
    chooseName: "Choose Second Item",
    showCustomTitle:false,
    name: "",
    cal: 0,
    image: "",
    flag: "123",
  },
  {
    id: "3",
    title: "item #3",
    sm_title: 'Drink',
    chooseName: "Choose Your Drink",
    showCustomTitle:true,
    customTitle:'Add Your Drink',
    name: "",
    cal: 0,
    image: "",
    flag: "123",
  },
];

export const isOrderCompleted = (KidsComboSelectionData) => {
  let shouldShow = true;
  KidsComboSelectionData.forEach((item) => {
    if (!item.name) shouldShow = false;
  });
  return shouldShow;
};

export default KidsComboSelectionData;
